import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import axios from "axios";

export default function ManageGaleri() {
  const [list, setList] = useState([]);
  const ref = collection(db, "galeri");

  /* ================= FETCH DATA ================= */
  const fetchData = async () => {
    const snap = await getDocs(ref);
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setList(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= CLOUDINARY UPLOAD (PALING AMAN) ================= */
  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    try {
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/auto/upload`,
        formData
      );
      return res.data.secure_url;
    } catch (error) {
      console.error("Cloudinary error:", error.response?.data || error);
      throw error;
    }
  };

  /* ================= TAMBAH GALERI ================= */
  const handleAdd = async () => {
    const { value: form } = await Swal.fire({
      title: "Tambah Galeri",
      html: `
        <input id="keterangan" class="swal2-input" placeholder="Keterangan">
        <select id="type" class="swal2-select">
          <option value="foto">Foto</option>
          <option value="video">Video</option>
        </select>
        <input id="url" class="swal2-input" placeholder="URL Media (opsional)">
        <input id="file" type="file" class="swal2-file">
      `,
      showCancelButton: true,
      confirmButtonText: "Simpan",
      preConfirm: () => ({
        keterangan: document.getElementById("keterangan").value,
        type: document.getElementById("type").value,
        url: document.getElementById("url").value,
        file: document.getElementById("file").files[0],
      }),
    });

    if (!form || (!form.url && !form.file)) {
      return Swal.fire("Validasi", "File atau URL wajib diisi", "warning");
    }

    // 🔒 validasi ukuran video
    if (form.file && form.type === "video") {
      if (form.file.size > 100 * 1024 * 1024) {
        return Swal.fire(
          "Ukuran terlalu besar",
          "Video maksimal 100MB",
          "warning"
        );
      }
    }

    let finalUrl = form.url;

    if (form.file) {
      try {
        finalUrl = await uploadToCloudinary(form.file);
      } catch {
        return Swal.fire(
          "Upload gagal",
          "Cloudinary menolak file",
          "error"
        );
      }
    }

    await addDoc(ref, {
      keterangan: form.keterangan,
      url: finalUrl,
      type: form.type,
      createdAt: new Date(),
    });

    Swal.fire("Berhasil", "Galeri ditambahkan", "success");
    fetchData();
  };

  /* ================= EDIT GALERI ================= */
  const handleEdit = async (item) => {
    const { value: form } = await Swal.fire({
      title: "Edit Galeri",
      html: `
        <input id="keterangan" class="swal2-input" value="${item.keterangan || ""}">
        <select id="type" class="swal2-select">
          <option value="foto" ${item.type === "foto" ? "selected" : ""}>Foto</option>
          <option value="video" ${item.type === "video" ? "selected" : ""}>Video</option>
        </select>
        <input id="url" class="swal2-input" value="${item.url || ""}">
        <input id="file" type="file" class="swal2-file">
      `,
      showCancelButton: true,
      confirmButtonText: "Update",
      preConfirm: () => ({
        keterangan: document.getElementById("keterangan").value,
        type: document.getElementById("type").value,
        url: document.getElementById("url").value,
        file: document.getElementById("file").files[0],
      }),
    });

    if (!form) return;

    let finalUrl = form.url;

    if (form.file) {
      try {
        finalUrl = await uploadToCloudinary(form.file);
      } catch {
        return Swal.fire(
          "Upload gagal",
          "Cloudinary menolak file",
          "error"
        );
      }
    }

    await updateDoc(doc(db, "galeri", item.id), {
      keterangan: form.keterangan,
      url: finalUrl,
      type: form.type,
      updatedAt: new Date(),
    });

    Swal.fire("Berhasil", "Galeri diperbarui", "success");
    fetchData();
  };

  /* ================= HAPUS GALERI ================= */
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Hapus media?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Hapus",
    });

    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "galeri", id));
    Swal.fire("Terhapus", "Media berhasil dihapus", "success");
    fetchData();
  };

  /* ================= UI ================= */
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between mb-3">
        <h3>Kelola Galeri</h3>
        <button className="btn btn-primary" onClick={handleAdd}>
          + Tambah Galeri
        </button>
      </div>

      <div className="row">
        {list.length === 0 ? (
          <p>Belum ada media</p>
        ) : (
          list.map((item) => (
            <div key={item.id} className="col-md-3 mb-3">
              <div className="card shadow-sm h-100">
                {item.type === "foto" ? (
                  <img
                    src={item.url}
                    alt={item.keterangan}
                    className="card-img-top"
                    style={{ height: 180, objectFit: "cover" }}
                  />
                ) : (
                  <video
                    src={item.url}
                    controls
                    style={{ width: "100%", height: 180, objectFit: "cover" }}
                  />
                )}
                <div className="card-body text-center p-2">
                  <p className="small text-muted">{item.keterangan}</p>
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(item.id)}
                    >
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
